module.exports = __webpack_public_path__ + "media/fastweb_volunteers/ds-snapchat-300x250-5d1ffa1c.jpg";